import React from 'react';
import { FadeIn, CTAButton } from './Shared';
import { XCircle } from 'lucide-react';
export const HeroSection = () => {
  return <section className="relative pt-12 pb-10 px-4 md:pt-32 md:pb-24 overflow-hidden" data-id="element-10">
      <div className="max-w-4xl mx-auto text-center" data-id="element-11">
        <FadeIn data-id="element-12">
          <h1 className="font-playfair text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4 md:mb-6" data-id="element-13">
            El Método <span className="text-gold" data-id="element-14">Acento Prohibido</span>: Cómo
            conquistar americanas usando tu "mal inglés" como ventaja injusta.
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-15">
          <h2 className="font-inter text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-8 md:mb-12 leading-relaxed" data-id="element-16">
            Deja de ser el "invisible que solo trabaja" y conviértete en el
            hombre exótico y misterioso que ellas no encuentran en el mercado
            americano.
          </h2>
        </FadeIn>

        <FadeIn delay={0.3} className="flex justify-center mb-10 md:mb-16" data-id="element-17">
          <div className="relative w-56 md:w-80 shadow-2xl shadow-gold/20 rounded-lg overflow-hidden border border-gold/20" data-id="element-18">
            <img src="https://cdn.magicpatterns.com/uploads/57fM6CCJTufct8QSbkiT7n/Portada_seduccion_a_gringa.png" alt="El Método Acento Prohibido Book Cover" className="w-full h-auto object-cover" data-id="element-19" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent pointer-events-none" data-id="element-20"></div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="max-w-2xl mx-auto text-left mb-8 md:mb-12" data-id="element-21">
          <p className="font-inter text-gray-300 mb-4 md:mb-6 leading-relaxed text-base md:text-lg" data-id="element-22">
            <span className="text-gold font-semibold" data-id="element-23">
              Es domingo por la noche.
            </span>{' '}
            Has trabajado 60 horas esta semana, tienes dólares en el bolsillo,
            pero estás solo en tu habitación mirando el teléfono. Ves a las
            mujeres allá afuera —las gringas— y te sientes a años luz de
            distancia porque piensas que tu acento es una debilidad y tu inglés
            no es perfecto.
          </p>
          <p className="font-inter text-gray-300 leading-relaxed text-base md:text-lg" data-id="element-24">
            Te han mentido. Te han hecho creer que hasta que no hables como un
            presentador de noticias, no existes para ellas. La realidad es mucho
            más emocionante:{' '}
            <strong className="text-white" data-id="element-25">
              tu acento no es un obstáculo, es tu mayor imán sexual si sabes
              cómo usarlo.
            </strong>
          </p>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-26">
          <CTAButton data-id="element-27" />
        </FadeIn>
      </div>
    </section>;
};
export const ProblemSection = () => {
  return <section className="py-10 md:py-16 px-4 bg-dark-card border-y border-dark-border" data-id="element-28">
      <div className="max-w-3xl mx-auto" data-id="element-29">
        <FadeIn data-id="element-30">
          <h3 className="font-playfair text-3xl md:text-4xl text-gold mb-5 md:mb-8 text-center" data-id="element-31">
            El Error Fatal
          </h3>
          <p className="font-inter text-gray-300 text-base md:text-lg leading-relaxed mb-4 md:mb-6" data-id="element-32">
            El hombre latino en EE.UU. comete el error de intentar "encajar".
            Intentas traducir mentalmente, te pones nervioso cuando no
            encuentras la palabra y terminas pidiendo perdón por tu inglés. Esa
            inseguridad mata cualquier atracción al instante.
          </p>
          <p className="font-inter text-gray-300 text-base md:text-lg leading-relaxed" data-id="element-33">
            Mientras tú te escondes por miedo a sonar "mal", las mujeres
            americanas están aburridas de los hombres locales. Están cansadas de
            tipos predecibles, suaves y políticamente correctos que hablan mucho
            pero no transmiten nada.{' '}
            <strong className="text-white" data-id="element-34">
              Ellas tienen hambre de algo real, rústico y masculino.
            </strong>
          </p>
        </FadeIn>
      </div>
    </section>;
};
export const FailedApproaches = () => {
  const failures = ['Intentar aprender inglés gramatical antes de salir a ligar te hace perder años de oportunidades.', 'Usar traductores en el bar te hace ver dependiente y de bajo estatus.', "Ser 'demasiado simpático' para compensar el idioma te manda directo a la friendzone.", 'Tratar de actuar como un americano te convierte en una copia barata, en lugar de ser un original exótico.'];
  return <section className="py-12 md:py-20 px-4" data-id="element-35">
      <div className="max-w-3xl mx-auto" data-id="element-36">
        <FadeIn data-id="element-37">
          <h3 className="font-playfair text-3xl md:text-4xl text-center mb-8 md:mb-12" data-id="element-38">
            Por qué lo que has intentado{' '}
            <span className="text-red-500" data-id="element-39">no funciona</span>
          </h3>
          <div className="space-y-4 md:space-y-6" data-id="element-40">
            {failures.map((text, index) => <div key={index} className="flex items-start gap-3 md:gap-4 p-3 md:p-4 rounded-lg bg-dark-card/50 border border-red-900/30" data-id="element-41">
                <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-42" />
                <p className="font-inter text-gray-300 text-base md:text-lg" data-id="element-43">
                  {text}
                </p>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
};